module.exports = __webpack_public_path__ + "img/f37.139c143f.png";